const REQUEST_PV_FORECAST_LOCATION = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_PV_FORECAST_LOCATION = (state, { body }) => {
  state.status = "success";
  state.forecast = body;
};

const FAILURE_REQUEST_PV_FORECAST_LOCATION = state => {
  state.status = "failure";
};

const REQUEST_SOLAR_HA = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_SOLAR_HA = (state, { body }) => {
  state.status = "success";
  state.forecast = body;
};

const FAILURE_REQUEST_SOLAR_HA = state => {
  state.status = "failure";
};

const REQUEST_MIX_PRICE = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_MIX_PRICE = (state, { body }) => {
  state.status = "success";
  state.forecast = body;
};

const FAILURE_REQUEST_MIX_PRICE = state => {
  state.status = "failure";
};


export default {
  REQUEST_PV_FORECAST_LOCATION,
  SUCCESS_REQUEST_PV_FORECAST_LOCATION,
  FAILURE_REQUEST_PV_FORECAST_LOCATION,

  REQUEST_SOLAR_HA,
  SUCCESS_REQUEST_SOLAR_HA,
  FAILURE_REQUEST_SOLAR_HA,

  REQUEST_MIX_PRICE,
  SUCCESS_REQUEST_MIX_PRICE,
  FAILURE_REQUEST_MIX_PRICE,
};
